import { createSlice } from "@reduxjs/toolkit";


export const initialState = {
    tokens: JSON.parse(localStorage.getItem('TOKENS')) || 0,
    data: JSON.parse(localStorage.getItem('MEMBER_DATA')) || null,
    address: JSON.parse(localStorage.getItem('ADDRESS')) || null,
    isVerified: JSON.parse(localStorage.getItem('IS_VERIFIED')) || false,
    subscription: JSON.parse(localStorage.getItem('SUBSCRIPTION')) || null,
    subscriptionType: localStorage.getItem('SUBSCRIPTION_TYPE') || 'free',
    favouriteCompetitions: [],
};


export const memberSlice = createSlice({
    name: 'Member',
    initialState,
    reducers: {
        setMemberData: (state, action) => {
            state.data = action.payload;
            state.address = action.payload ? action.payload.address : null;
            state.tokens = action.payload ? action.payload.freeTokens : [];
            state.subscription = action.payload ? action.payload.subscription : null;
            state.subscriptionType = action.payload ? action.payload.subscriptionType : 'free';
            state.isVerified = action.payload ? action.payload.isVerified : false;
            localStorage.setItem('TOKENS', JSON.stringify(action.payload ? action.payload.freeTokens : 0));
            localStorage.setItem('SUBSCRIPTION: ', JSON.stringify(action.payload ? action.payload.subscription : null));
            localStorage.setItem('SUBSCRIPTION_TYPE', JSON.stringify(action.payload ? action.payload.subscriptionType : 'free'));
            localStorage.setItem('ADDRESS', JSON.stringify(action.payload ? action.payload.address : null));
            localStorage.setItem('MEMBER_DATA', JSON.stringify(action.payload));
            localStorage.setItem('IS_VERIFIED', 'false');
        },
        setAddressData: (state, action) => {
            state.address = action.payload;
            localStorage.setItem('ADDRESS', JSON.stringify(action.payload));
        },
        setFavouriteCompetitions: (state, action) => {
            state.favouriteCompetitions = action.payload;
            localStorage.setItem('FAVOURITE_COMPETITIONS', JSON.stringify(action.payload));
        },
        resetMember: (state) => {
            state.data = null;
            state.tokens = 0;
            state.address = null;
            state.isVerified = false;
            state.subscription = null;
            state.subscriptionType = 'free';
            state.favouriteCompetitions = [];
            localStorage.removeItem('TOKENS');
            localStorage.removeItem('ADDRESS');
            localStorage.removeItem('MEMBER_DATA');
            localStorage.removeItem('SUBSCRIPTION');
            localStorage.setItem('IS_VERIFIED', 'false');
            localStorage.setItem('SUBSCRIPTION_TYPE', 'free');
            localStorage.removeItem('FAVOURITE_COMPETITIONS');
        },
    },
});

export const { setMemberData, setAddressData, setFavouriteCompetitions, resetMember } = memberSlice.actions;


export default memberSlice.reducer;